<template>
  <v-row>
    <div :style="{
        height: '40px',
        width: '5px',
        backgroundColor: color,
        margin: '10px 0'
      }" />
    <v-col>
      <v-row>
        <v-col cols="2">
          <v-text-field
            v-model="value.name"
            :label="$t('common.name')"
            dense
            outlined
            @change="validate.name.$touch()"
            @input="$emit('input', value)"
            :error-messages="[...errorMessages('name'), nameError ].filter(i => !!i)"
            :disabled="disabled"
          />
        </v-col>
        <v-col cols="3">
          <vf-date-input
            v-model="value.originalDate"
            :label="$t('payment.milestone.date')"
            outlined
            dense
            :disabled="disabled"
            @input="handlePickerChange"
            @change="validate.originalDate.$touch()"
            :error-messages="errorMessages('originalDate')"
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="value.percentOfMilestone"
            :label="$t('payment.milestone.percentOf', { name: paymentName })"
            dense
            outlined
            type="number"
            :min="0"
            :max="100"
            @input="handlePercentChange"
            @change="validate.percentOfMilestone.$touch()"
            :error-messages="errorMessages('percentOfMilestone')"
            append-icon="mdi-percent-outline"
            :disabled="disabled"
          />
        </v-col>
        <v-col cols="4">
          <div v-if="!isVariation"> <b>{{percentOfContractPrice | toFixed}}%</b> {{ $t('payment.milestone.ofContract') }}</div>
          <div> {{ $t('payment.milestone.paymentAmount') }} <b>{{paymentAmountCents | formatCurrency(currency) }}</b> </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { errorMessageGenerator } from '@/validators'

export default {
  name: 'SubMilestoneEditRow',
  props: {
    value: Object,
    color: String,
    validate: Object,
    paymentPaymentAmount: Number,
    percentToCover: Number,
    paymentName: String,
    contractPrice: Object,
    isVariation: Boolean,
    currency: Object,
    nameDuplicateError: Function
  },
  data () {
    return {
      originalDateMenu: false,
      amountError: null,
      key: 0
    }
  },
  computed: {
    nameError () {
      return this.nameDuplicateError(this.value.name)
    },
    paymentAmountCents () {
      return this.value.paymentAmountCents
    },
    percentOfMilestone () {
      return this.value.percentOfMilestone
    },
    percentOfContractPrice () {
      return (this.value.paymentAmountCents / this.contractPrice.sum) * 100
    },
    disabled () {
      return isNaN(this.value.amountAssignedToApplication) ? !!this.value.amountAssignedToApplication.sum : !!this.value.amountAssignedToApplication
    }
  },
  methods: {
    handlePercentChange () {
      this.value.paymentAmountCents =
        this.paymentPaymentAmount *
        (Number(this.value.percentOfMilestone) / 100)
      this.$emit('input', this.value)
    },
    handlePickerChange () {
      this.originalDateMenu = false
      this.value.forecastedDate = this.value.originalDate
      this.$emit('input', this.value)
    },
    errorMessages (key) {
      return errorMessageGenerator(this.validate[key], key)
    }
  },
  watch: {
    percentOfMilestone (v) {
      if (this.percentToCover < 0) {
        this.value.percentOfMilestone = Number(v) + this.percentToCover
        this.value.paymentAmountCents =
          this.paymentPaymentAmount * (this.value.percentOfMilestone / 100)
        this.$emit('input', this.value)
      }
    }
  }
}
</script>
